import { api } from './client'

export async function listInvites({ includeClosed = false } = {}) {
  const { data } = await api.get('/invites', {
    params: includeClosed ? { include_closed: true } : undefined,
  })
  return data
}

export async function createInvite(body) {
  const { data } = await api.post('/invites', body)
  return data
}

export async function regenerateInvite(inviteId) {
  const { data } = await api.post(`/invites/${inviteId}/regenerate`)
  return data
}

export async function revokeInvite(inviteId) {
  const { data } = await api.post(`/invites/${inviteId}/revoke`)
  return data
}

export async function previewInvite(token) {
  const { data } = await api.get(`/invites/by-token/${encodeURIComponent(token)}`)
  return data
}

export async function acceptInvite(token, body) {
  const { data } = await api.post(
    `/invites/by-token/${encodeURIComponent(token)}/accept`,
    body,
  )
  return data
}
